import { render, staticRenderFns } from "./edit-pop.vue?vue&type=template&id=53029e8f"
import script from "./edit-pop.vue?vue&type=script&lang=js"
export * from "./edit-pop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports